export const UPDATE_SELECTED_CLIENT = 'UPDATE_SELECTED_CLIENT';

export const updateSelectedClient = (selectedClient) => ({
  type: UPDATE_SELECTED_CLIENT,
  payload: { selectedClient }
});
